import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { getTriviaFileName } from "../data";
import { withFolderQuery } from "../Components/backNav";
import LibraryQuestions from "./LibraryQuestions";
import LibraryTrivvys from "./LibraryTrivvys";
import { connect } from "react-redux";
import Loading from "../../../hoc/Loading/Loading";
import ReactTooltip from "react-tooltip";
import * as actionCreators from "../../../modules/actions";
import {
  LibraryAccessDenied,
  getApiErrorBody,
} from "../../public/LibraryShare/libraryShareShared";

const LIBRARY_UNAVAILABLE_MESSAGE =
  "This Library item is not available. It may have been removed.";

function TriviaLibraryViewPage({ updateLibraryTrivvyCount, ...props }) {
  const [libraryDoc, setLibraryDoc] = useState(null);
  const [menu, setMenu] = useState(1);
  const [libQuestions,setLibQuestions] = useState([])
  // Set when the item can't be shown: { message, name?, kind? } (TBV-951).
  const [accessIssue, setAccessIssue] = useState(null);

  let opt2 = 'trivvys'
  let opt1 = 'questions'

  const updateLibraryDoc=(data)=>{
    setLibraryDoc(data)
  }

  // 403: the item exists but is private to this user (e.g. Only Me) — the BE
  // sends its name and kind for the permission notice. Anything else: missing,
  // deleted or unreachable (TBV-938 / TBV-951).
  const handleLibraryLoadError = (error) => {
    console.log(error);
    const status = error && error.response && error.response.status;
    const body = getApiErrorBody(error) || {};
    if (status === 403 && body.message) {
      setAccessIssue({ message: body.message, name: body.name, kind: body.kind });
    } else {
      setAccessIssue({ message: LIBRARY_UNAVAILABLE_MESSAGE });
    }
  };


  useEffect(() => {
    const libraryId = props.match.params.id;
    const tab = props.match.params.tab;
    if (tab === opt1) {
      setMenu(1);
    }
    if (tab === opt2) {
      setMenu(2);
    }
    axios.get(url.getTriviaLibraryById(libraryId)).then(({ data }) => {
      setAccessIssue(null);
      setLibraryDoc(data.data);
      updateLibraryTrivvyCount({
        typeTrivvy: "SET",
        valueTrivvy: data.data.triviaCount,
      });
    }).catch(handleLibraryLoadError);
  }, []);

  useEffect(() => {

    const tab = props.match.params.tab;
    if (tab === opt1) {
      setMenu(1);
    }
    if (tab === opt2) {
      setMenu(2);
    }

    const libraryId = props.match.params.id;
    axios.get(url.getTriviaLibraryById(libraryId)).then(({ data }) => {
      setAccessIssue(null);
      setLibraryDoc(data.data);
      updateLibraryTrivvyCount({
        typeTrivvy: "SET",
        valueTrivvy: data.data.triviaCount,
      });
    }).catch(handleLibraryLoadError);
  }, [props.match.params.tab]);

  const selectMenu = num => {
    if (num === 1) {
      props.history.push(opt1);
    }
    if (num === 2) {
      props.history.push(opt2);
    }
    setMenu(num);
  };

  return (
    <div className="trivia_survey_edit_page">
      {accessIssue && (
        <LibraryAccessDenied
          embedded
          name={accessIssue.name}
          kind={accessIssue.kind}
          message={accessIssue.message}
        />
      )}
      {libraryDoc && props.user && (
        <div>
          <div className={`survey-top-div ${!isMobile && "pl-3"}`}>
            <Row
              className={`survey_detail_page_top_navbar bg-white ${
                isMobile ? "mx-0" : "pl-1"
              }`}
              style={{left:"18px"}}
            >
              <Col md={9}>
                <div className="d-flex align-items-center">
                  <span
                    className="survey_detail_page_top_wp"
                    onClick={() => {
                      props.history.push(
                        withFolderQuery(
                          `/home/trivia/${props.user.profile.organizationId._id}/library`,
                          libraryDoc.folderId
                        )
                      );
                    }}
                  >
                    Library -{" "}
                  </span>
                  <span
                    className="survey-item-title"
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    data-tip={getTriviaFileName({
                      uploadUrl: libraryDoc.s3Url,
                      uploadFileName: libraryDoc.s3Key,
                      showFull: true,
                      librarySourceType:libraryDoc.librarySourceType,
                      libName:libraryDoc.name,
                      webUrl: libraryDoc.webUrl

                    })}
                    data-for="trivvy_lib_title"
                  >
                    {getTriviaFileName({
                      uploadUrl: libraryDoc.s3Url,
                      uploadFileName: libraryDoc.s3Key,
                      librarySourceType:libraryDoc.librarySourceType,
                      libName:libraryDoc.name
                    })}
                  </span>
                  <ReactTooltip id="trivvy_lib_title" place="right" />
                </div>
              </Col>
            
            </Row>
          </div>
          <div>
            <div
              className={isMobile ? "px-2" : ""}
              style={{
                position: "relative",
                top: isMobile ? "60px" : "40px",
              }}
            >
              {menu == 2 ? (
                 <LibraryTrivvys updateLibraryDoc={updateLibraryDoc} libQuestions={libQuestions} library={libraryDoc} />
              ) : menu == 1 ? (
                <LibraryTrivvys updateLibraryDoc={updateLibraryDoc} libQuestions={libQuestions} library={libraryDoc} />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateLibraryTrivvyCount: data =>
      dispatch(actionCreators.updateSingleLibrarayStatsForTrivvyCount(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaLibraryViewPage, axios));
